import { FormattedMessage, useIntl } from 'react-intl';
import { isToday } from '@alltrails/data-formatting/dateTimeConverters';

type TrailReviewDateProps = {
  created: string;
};

const TrailReviewDate = ({ created }: TrailReviewDateProps) => {
  const intl = useIntl();

  const reviewDate = new Date(created);
  const yesterdayDate = new Date();
  yesterdayDate.setDate(new Date().getDate() - 1);
  const yesterdayStart = new Date(yesterdayDate.setHours(0, 0, 0, 0));

  if (reviewDate > yesterdayStart) {
    return isToday(created) ? <FormattedMessage defaultMessage="Today" /> : <FormattedMessage defaultMessage="Yesterday" />;
  }

  return intl.formatDate(reviewDate, {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
};

export default TrailReviewDate;
